<template>
  <div>

    <Row class="search-con">
      <Col span="24">
        <Button @click="backHistory" class="search-btn">返回</Button>
      </Col>
    </Row>

    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="120"
    >

      <FormItem label="语音类型" v-if="formValidate.id != 0">

        <Col span='5'>
          <RadioGroup v-model="formValidate.type" type="button">
          <Radio label="语音生成"></Radio>
          <Radio label="人工配音"></Radio>
          </RadioGroup>
        </Col>
        <Col span="2" offset="1">
            <Button type="primary"  @click="handleSubmit()"  style="margin-left: 8px">保存</Button>
        </Col>
 
      </FormItem>

      <FormItem label="语音类型" v-if="formValidate.type == '语音生成'">
        <RadioGroup v-model="formValidate.audio_type" type="button">
        <Radio label="语音模型"></Radio>
        <Radio label="辅助音频"></Radio>
        </RadioGroup>
      </FormItem>

      <FormItem label="声音模型" prop="audio_model_id" v-if="formValidate.audio_type == '语音模型' && formValidate.type == '语音生成'">
        <Col span='4'>
          <Select v-model="formValidate.audio_model_id">
            <Option
              v-for="item in audioModelIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name}}</Option
            >
          </Select>
        </Col>
        <Col span='15'>
          <audio :src="audioUrl + audio_data[formValidate.audio_model_id] + '.wav'" controls></audio>
        </Col>

      </FormItem>

      <FormItem label="请上传辅助音频文件" v-if="formValidate.audio_type == '辅助音频' && formValidate.type == '语音生成'" prop="audio_path">
        <input type="file" accept=".MP3,.mp3,.wav, .WAV"  @change="handleAudioFileChange" ref="audioRef"/>
      </FormItem>

      <FormItem label="请上传处理好的音频文件" v-if="formValidate.type == '人工配音'">
        <input type="file" accept=".MP3,.mp3,.wav"  @change="handleSourceFileChange" />
        <label class="search-label">{{show_source_path}}</label>
      </FormItem>

      
      <FormItem label="文案" v-if="formValidate.video_work_type != 1" >
        <Input v-model="formValidate.content" type="textarea"  placeholder="请填写文案"></Input>
      </FormItem>
    </Form>

    <Card v-if="tableData.length > 0">
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
    </Card>
    
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import { getCovertAudioDetail, audioModelList, editCovertAudioTask} from "@/api/data";

import moment from 'moment';
const { v4: uuidv4 } = require('uuid');
import {uploadFile} from "@/api/uploadOss";

export default {
  name: "finance",
  components: {
    Tables
  },
  data() {
    return {
      language:'印尼文',
      audio_data:{},
      formValidate: {
        id: '',
        type:'语音生成',
        audio_type:'语音模型',
        videoPath:'',
        audio_path:'',
        source_path:'',
        audio_model_id:'',
        srt_path:'',
        content:'',
        video_work_type:''
      },
      ruleValidate: {
        audio_path: [
          {
            required: true,
            message: '辅助音频必须上传',
            trigger: 'blur'
          }
        ], audio_model_id: [
          {
            required: true,
            message: '语音模型必须选择',
            trigger: 'change'
          }
        ]
      },
      audioUrl:'https://sinano-clother.oss-cn-shenzhen.aliyuncs.com/audio/',
      audioModelIds:[],
      goodItemLoadding:[],
      blackItemLoadding:[],
      page: 1,
      total: 0,
      pageSize: 10,
      status:'',
      addModal: false,
      editModal: false,
      resetFlag: false,
      editUserModal:false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      classify_id:'',
      startTime: "",
      endTime: "",
      dy_id:'',
      id:'',
      tag_status:'',
      live_id:'',
      tagStatusIds:[],
      tag_id:'',
      blacks:[{id: 1, name:"是"}, {id: 0, name:"否"}],
      is_black:'',
      tagStatusIds:[{id: 1, name:"已确认"}, {id: 0, name:"未确认"}],
      selectId:[],
      tag_id:'',
      tagIds:[],
      loadding_array:[false, false, false],
      loading:false,
      srt_item_loadding_array:[],
      columns: [
        {type: "index", title: '序号',width: 100,align: "center", align: "center"},
        { title: "时间轴" , key: "title", editable: true, align: "center", width:300},
        { title: "原始话术" , key: "translate_text", editable: true, align: "center", width:300},
        {title: "修改后话术", key: "new_text", align: "center",render: (h, params) => {
            return h("Input", {
              props: {
                value: params.row.new_text,
                size: "small",
                type: "textarea"
              },on: {
                'on-change': (event) => {
                  this.tableData[params.index].new_text = event.target.value;
                }
              }
            })
        }}, 
        { title: "操作" , editable: true,width: 200, align: "center",
            render: (h, params) => {
                return h("div", [
                  h(
                    "Button",
                    {
                      props: {
                        type: "error",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.deleteSrt(params.index);
                        },
                      },
                    },
                    "删除"
                  )
                ]);
              },
         }],
    tableData: [],
    };
  },
  methods: {
    backHistory() {
      this.$router.go(-1)
    }, 
    deleteSrt(index){
      this.tableData.splice(index, 1)
    },
    async handleAudioFileChange(e){
      try {
        const file = e.target.files[0];
        if (!file) return;
        this.formValidate.audio_path = await this.uploadFile(file)
        if (this.formValidate.audio_path != null){
            var org_audio_array = this.formValidate.audio_path.split("/")
            this.show_audio_path = org_audio_array[org_audio_array.length - 1]
        }

      } catch (error) {
        this.$Message.error('上传失败');
      }
    },
    async handleSourceFileChange(e){

      try {
        const file = e.target.files[0];
        if (!file) return;

        this.formValidate.source_path =  await this.uploadFile(file)
        if (this.formValidate.source_path != null){
            var org_source_array = this.formValidate.source_path.split("/")
            this.show_source_path = org_source_array[org_source_array.length - 1]
          }
      } catch (error) {
        this.$Message.error('上传失败');
      }
    },async uploadFile(file){

      // 上传文件
      let currentDate = moment().format('YYYY-MM-DD');
      const uuid = uuidv4()
      var name = file.name.substring(file.name.lastIndexOf('.'))
      var result = await uploadFile('short_video/' + currentDate + "/covert_audio/" + uuid + name, file);
      if (result == ''){
        this.$Message.error('上传失败');
        this.$refs.audioRef.value = ''
      }else{
        this.$Message.info('上传成功');
      }
      return result
    },
    async handleTranslateSrtFileChange(e){
      const file = e.target.files[0];
      if (!file) return;
        // 解析srt文件
        const reader = new FileReader();
        var srtText = ''
        reader.onload = e => {
          srtText = e.target.result;
          var srt_array = this.parseSRT(srtText)
          for (var i = 0; i < srt_array.length; i++){
            var item = srt_array[i]
            this.tableData[i].translate_text = item.text
            this.tableData[i].after_text = ""
          }
        };
        reader.readAsText(file)
        
    }, generateSRT(subtitles) {
      let srtContent = '';
      subtitles.forEach((subtitle, index) => {
        const sequenceNumber = index + 1;
        const startTime = subtitle.startTime
        const endTime = subtitle.endTime
        srtContent += `${sequenceNumber}\n${startTime} --> ${endTime}\n${subtitle.new_text}\n\n`;
      });
      return srtContent;
    },parseSRT(content) {
      // 按行拆分内容
      const lines = content.trim().split(/\r?\n/);
      const subtitles = [];

      // 用于临时存储每个字幕块的变量
      let subtitleBlock = {
        index: null,
        startTime: null,
        endTime: null,
        text: ''
      };

      // 遍历每一行内容
      lines.forEach(line => {
        if (!subtitleBlock.index) {
          // 解析字幕序号
          subtitleBlock.index = parseInt(line);
        } else if (!subtitleBlock.startTime) {
          // 解析时间轴的起始时间
          const [startTime, endTime] = line.split(' --> ').map(time => time.trim());
          subtitleBlock.startTime = startTime;
          subtitleBlock.endTime = endTime;
        } else if (line.trim() === '') {
          // 遇到空行时，保存当前字幕块并重置临时变量
          subtitles.push(subtitleBlock);
          subtitleBlock = {
            index: null,
            startTime: null,
            endTime: null,
            text: ''
          };
        } else {
          // 解析字幕文本内容
          subtitleBlock.text += line.trim() + ' ';
        }
      });

      return subtitles;
    }, 
    async handleSubmit () {
      var srtContent = this.generateSRT(this.tableData)
      var url = ''
      if (srtContent != ''){
        const blob = new Blob([srtContent], { type: 'text/plain' });
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        url = await uploadFile('short_video/' + currentDate + "/covert_audio/" + uuid + ".srt", blob);
      }

      var type = 1
      if (this.formValidate.type == '语音生成'){
          type = 0
      }
      const data = {
        audio_model_id: this.formValidate.audio_model_id,
        audio_path: this.formValidate.audio_path,
        source_path: this.formValidate.source_path,
        type: type,
        srt_json:JSON.stringify(this.tableData),
        content: this.formValidate.content,
        srt_path: url
      };

      editCovertAudioTask(data, this.formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });

    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    translate(params){

    }, covertTime(time_str){
      var start_split = time_str.split(":")

    // 00:00:15,000  解析这个格式，转换成毫秒
    if (start_split.length > 2) {
        var hour_second = parseInt(start_split[0]) * 60 * 60 * 1000
        var m_second = parseInt(start_split[1]) * 60 * 1000
        var second_split = start_split[2].split(",")
        var second = 0
        var mm_second = 0
        if (second_split.length > 1) {
            second = parseInt(second_split[0]) * 1000
            mm_second = parseInt(second_split[1])
        }
        return hour_second + m_second + second + mm_second + ""
    }
    }, setEditData(params){
        this.formValidate.id = params.id.toString()
        if (params.type == 0){
          this.formValidate.type = "语音生成"
        }else{
          this.formValidate.type = "人工配音"
        }

        this.formValidate.source_path = params.source_path
        this.formValidate.audio_path = params.audio_path
        this.formValidate.srt_path = params.srt_path
        this.formValidate.audio_model_id = params.audio_model_id.toString()
        this.status = params.status
        if (params.source_path != null){
          var video_source_array = params.source_path.split("/")
          this.show_source_path = video_source_array[video_source_array.length - 1]
        }

        if (params.audio_path != null){
          var video_audio_array = params.audio_path.split("/")
          this.show_audio_path = video_audio_array[video_audio_array.length - 1]
        }
        
        this.status = params.status
        this.formValidate.content = params.content
        this.formValidate.video_work_type = params.translateText.checkSrtTask.shortVideoTask.short_video_work_type_id
        if (params.srt_json != null){
          var srt_array =  JSON.parse(params.srt_json)
          this.tableData = []
          for (var i = 0; i < srt_array.length; i++){
            var item = srt_array[i]
            var endTime = this.covertTime(item.endTime)
            var startTime = this.covertTime(item.startTime)
            
            var new_text = ''
            if (item.new_text != null && item.new_text.length > 0){
              new_text = item.new_text
            }else{
              if (item.update_translate_text != null && item.update_translate_text.length > 0){
                new_text = item.update_translate_text
              }else{
                new_text = item.translate_text
              }
            }

            this.tableData.push({"title":item.startTime + "---" + item.endTime + "长度:" + (endTime - startTime) + "毫秒", "translate_text":item.translate_text, "new_text":new_text, "startTime": item.startTime, 'endTime': item.endTime, "is_confirm": ''})
            this.srt_item_loadding_array.push(false)
          }
        }

    },
    backHistory() {
      this.$router.go(-1);
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },getDetail(){
      var params = {
        id:this.id
      }
      getCovertAudioDetail(params).then((res) => {
        if (res.data.code == 200) {
          var detailData = res.data.data
          this.setEditData(detailData)
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });

    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetail()

    audioModelList().then((res) => {
      var audioModelList = res.data.data.records;
      var data = new Array()
      for (var i = 0; i < audioModelList.length; i++) {
        data[i] = { id: audioModelList[i].id.toString(), name: audioModelList[i].audio_name}
        this.audio_data[audioModelList[i].id.toString()] = audioModelList[i].audio_id
      }
      this.audioModelIds = data
    });
  },
};
</script>
